import script from "./ModalDetalleDiseno.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDetalleDiseno.vue?vue&type=script&setup=true&lang=js"

import "./ModalDetalleDiseno.vue?vue&type=style&index=0&id=74a4835e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74a4835e"]])

export default __exports__